import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-20 h-20 rounded-2xl bg-primary-50 flex items-center justify-center mb-6">
        <i className="ri-error-warning-line text-primary-500 text-4xl w-10 h-10 flex items-center justify-center"></i>
      </div>
      <h1 className="font-heading font-bold text-6xl md:text-8xl text-foreground-950 mb-4">
        404
      </h1>
      <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground-800 mb-3">
        Página não encontrada
      </h2>
      <p className="text-foreground-500 text-base max-w-md mb-8">
        A página que procura não existe ou foi movida. Verifique o endereço ou volte à página inicial.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-colors whitespace-nowrap"
      >
        <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
        {t('nav.home')}
      </Link>
      <p className="mt-4 text-xs text-foreground-400 font-mono">{location.pathname}</p>
    </div>
  );
}